import { createContext, useEffect, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var ServiceConfigContext = /*#__PURE__*/createContext({
  baseUrl: ''
});
export var ServiceProvider = function ServiceProvider(_ref) {
  var children = _ref.children,
      inputBaseUrl = _ref.baseUrl,
      inputJwt = _ref.jwt;

  var _useState = useState(inputJwt),
      jwt = _useState[0],
      setJwt = _useState[1];

  var _useState2 = useState(inputBaseUrl),
      baseUrl = _useState2[0],
      setBaseUrl = _useState2[1];

  useEffect(function () {
    return setJwt(inputJwt);
  }, [inputJwt]);
  useEffect(function () {
    return setBaseUrl(baseUrl);
  }, [baseUrl]);
  return /*#__PURE__*/_jsx(ServiceConfigContext.Provider, {
    value: {
      baseUrl: baseUrl,
      jwt: jwt
    },
    children: children
  });
};